/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDashboardsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListDashboardsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListDashboardsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDashboardsSecurity$outboundSchema: z.ZodMiniType<
  ListDashboardsSecurity$Outbound,
  ListDashboardsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listDashboardsSecurityToJSON(
  listDashboardsSecurity: ListDashboardsSecurity,
): string {
  return JSON.stringify(
    ListDashboardsSecurity$outboundSchema.parse(listDashboardsSecurity),
  );
}

/** @internal */
export type ListDashboardsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListDashboardsRequest$outboundSchema: z.ZodMiniType<
  ListDashboardsRequest$Outbound,
  ListDashboardsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listDashboardsRequestToJSON(
  listDashboardsRequest: ListDashboardsRequest,
): string {
  return JSON.stringify(
    ListDashboardsRequest$outboundSchema.parse(listDashboardsRequest),
  );
}
